import { Pipe, PipeTransform } from '@angular/core';
import { References } from '../references';

@Pipe({
	name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
	transform(value: unknown, ...args: unknown[]): unknown {
		try {
			const phoneFormat = References.phoneNumberToDisplayFormat(value.toString());
			return phoneFormat;
		} catch (error) {
			return value;
		}
	}
}
